import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Claim -3 Bill Information")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim No"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "number",
    name: "name",
    value: 3,
    class: "form-control",
    disabled: ""
  })
], -1)
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill Date", -1)
const _hoisted_22 = { class: "col-md-2 mt-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = { class: "card mb-5 mb-xl-10" }
const _hoisted_27 = {
  id: "assessor_data",
  class: "collapse show"
}
const _hoisted_28 = { class: "collapse show" }
const _hoisted_29 = { class: "card-body border-top p-6" }
const _hoisted_30 = { class: "table-responsive mt-5" }
const _hoisted_31 = { class: "table table-borderless gy-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"180px"}
    }, " Training Institutes "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"width":"180px"}
    }, "Course"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "Batch No"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "3",
      class: "text-center"
    }, " Net Count "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center"
    }, "Employment")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Claim-1(A)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim-2(B)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim-3(C)"),
    /*#__PURE__*/_createElementVNode("th", null, "JOB Count(D)"),
    /*#__PURE__*/_createElementVNode("th", null, "JOB(D/C)%")
  ])
], -1)
const _hoisted_33 = { style: {} }
const _hoisted_34 = { class: "align-middle" }
const _hoisted_35 = { class: "align-middle" }
const _hoisted_36 = { class: "align-middle" }
const _hoisted_37 = { class: "align-middle" }
const _hoisted_38 = { class: "align-middle" }
const _hoisted_39 = { class: "align-middle" }
const _hoisted_40 = { class: "align-middle" }
const _hoisted_41 = { class: "align-middle" }
const _hoisted_42 = { class: "align-middle" }
const _hoisted_43 = { style: {"border-bottom":"1px solid\r\n                                    rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "font-weight-bold text-black"
}, " Total ", -1)
const _hoisted_45 = { class: "font-weight-bold text-black" }
const _hoisted_46 = { class: "font-weight-bold text-black" }
const _hoisted_47 = { class: "font-weight-bold text-black" }
const _hoisted_48 = { class: "font-weight-bold text-black" }
const _hoisted_49 = { class: "font-weight-bold text-black" }
const _hoisted_50 = { class: "font-weight-bold text-black" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-info p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}, " Bill Attachments ", -1)
const _hoisted_52 = ["data-kt-indicator"]
const _hoisted_53 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_54 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_55 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Tranche",
                  modelValue: _ctx.bill.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: trans.id,
                        label: trans.label,
                        value: trans.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trans.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Partner",
                  modelValue: _ctx.bill.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getEntityContract()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.entity_short_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Contract",
                  modelValue: _ctx.bill.entity_contract_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAllBillNo()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.contract_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.contract_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Bill",
                  modelValue: _ctx.bill.bill_sequence_no,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bill.bill_sequence_no) = $event)),
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: bl.bill_sequence_no,
                        label: bl.bill_no,
                        value: bl.bill_sequence_no
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bl.bill_no), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_el_form_item, { prop: "end_date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.bill.bill_date,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bill.bill_date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      format: "DD-MM-YYYY",
                      style: {"width":"100%"},
                      type: "date",
                      name: "bill_date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getBatchList())),
                  type: "button",
                  class: "btn btn-success mt-4 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_23
                ])
              ])
            ]),
            (_openBlock(), _createElementBlock("div", { key: _ctx.claimBillkey }, [
              (_ctx.showBillList == true && _ctx.billList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("h3", _hoisted_25, " Selected Batches for Employment Bill Claim (Total Batch Found : " + _toDisplayString(_ctx.billList.length) + ") ", 1),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("table", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("tbody", _hoisted_33, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (data, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: index,
                                      style: {"border-bottom":"1px solid\r\n                                      rgba(29, 182, 140, 0.51) !important"}
                                    }, [
                                      _createElementVNode("td", _hoisted_34, _toDisplayString(index + 1), 1),
                                      _createElementVNode("td", _hoisted_35, _toDisplayString(data?.bill_list?.institute_info
                                        ?.institute_name) + " ( " + _toDisplayString(data?.bill_list?.institute_info
                                        ?.short_name) + " ) ", 1),
                                      _createElementVNode("td", _hoisted_36, _toDisplayString(data?.bill_list?.course_info?.course_name) + " | " + _toDisplayString(data?.bill_list?.course_info?.month) + " | " + _toDisplayString(data?.bill_list?.course_info?.hour) + " | " + _toDisplayString(data?.bill_list?.course_info
                                        ?.unit_cost_total), 1),
                                      _createElementVNode("td", _hoisted_37, _toDisplayString(data?.bill_list?.batch_info?.batch_sequence_number), 1),
                                      _createElementVNode("td", _hoisted_38, _toDisplayString(data?.bill_list?.enroll_count), 1),
                                      _createElementVNode("td", _hoisted_39, _toDisplayString(data?.bill_list?.trainee_count), 1),
                                      _createElementVNode("td", _hoisted_40, _toDisplayString(data?.claim3_trainee), 1),
                                      _createElementVNode("td", _hoisted_41, _toDisplayString(data?.employment_trainee), 1),
                                      _createElementVNode("td", _hoisted_42, _toDisplayString(parseFloat((data?.employment_trainee/data?.claim3_trainee) * 100).toFixed(2)) + "% ", 1)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", _hoisted_43, [
                                    _hoisted_44,
                                    _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.billList.length), 1),
                                    _createElementVNode("th", _hoisted_46, _toDisplayString(Number(_ctx.totalClaim1Trainee).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_47, _toDisplayString(Number(_ctx.totalClaim2Trainee).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_48, _toDisplayString(Number(_ctx.totalClaim3Trainee).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_49, _toDisplayString(Number(_ctx.totalEmployeedTrainee).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_50, _toDisplayString(parseFloat(_ctx.totalEmpoymentPer).toFixed(2)) + "% ", 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_51,
                    _createElementVNode("button", {
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      class: "btn btn-success ml-3 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                      type: "submit",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmSubmitBill()))
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                            _createTextVNode(" Submit Bill "),
                            _createElementVNode("span", _hoisted_54, [
                              _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                            _createTextVNode(" Please wait... "),
                            _hoisted_56
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_52)
                  ]))
                : _createCommentVNode("", true)
            ]))
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}